import { FiEdit2 } from "react-icons/fi";
import { useContext, useEffect, useState } from "react";
import { DataProvider } from "../../store/ContextProvider";
import { fetchCandidateEducation } from "../../services/Candidate Portal/Profile/fetchCandidateDetails";
import { LiaGraduationCapSolid } from "react-icons/lia";
import { useLocation, useNavigate } from "react-router-dom";

function Education({ candidate, currentUser }) {



    const { BeURL } = useContext(DataProvider)
    const [educations, setEducations] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerpage] = useState(5);
    const [totalPage, setTotalPage] = useState(0);
    const [totalEducation, setTotalEducation] = useState(0)

    useEffect(() => {
        const fetchEducation = async () => {
            await fetchCandidateEducation(BeURL, candidate._id, currentPage, rowsPerPage, setTotalEducation, setTotalPage, setEducations)
        }
        fetchEducation()
    }, [currentPage, rowsPerPage, BeURL])

    useEffect(() => {
        setCurrentPage(1)
    }, [rowsPerPage])


    const handlePagination = (dir) => {
        if (dir === 'prev' && currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && currentPage < totalPage) {
            setCurrentPage(prev => prev + 1);
        }
    };
    const navigate = useNavigate()
    const location = useLocation()

    const formatNames = values =>
        values?.split(/[_-\s]/).map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');


    return (
        <div className="bg-white shadow rounded-lg p-4 sm:p-5 md:p-6 lg:p-8 xl:p-10 max-w-full  mx-auto">

            <div className="flex flex-row justify-between items-center"><h3 className="font-semibold text-lg md:text-xl mt-4">Educations</h3>
                {currentUser.role === 'job-seeker' && <FiEdit2 className="text-primary-500 text-xl font-bold" onClick={() => navigate(`/update-account/education?inverse=${true}&userId=${currentUser?._id}`, { state: { from: location.pathname, active: 'Education' } })} />}</div>
            <div className="flex flex-col gap-3 my-3 overflow-y-auto">
                {educations?.length > 0 ? (
                    educations.map((edu, i) => (
                        <div
                            key={i}
                            className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-5 px-3 sm:px-4 md:px-5 py-4 
              shadow-md rounded-lg"
                        >
                            {/* Left side */}
                            <div className="flex flex-col sm:flex-row gap-4 items-start">
                                <LiaGraduationCapSolid className="text-2xl text-secondary-300" />
                                <div className="flex flex-col">
                                    {edu?.courseType && (
                                        <p className="text-base sm:text-lg md:text-xl font-semibold text-black flex flex-wrap gap-2 items-center">
                                            {`${formatNames(edu.courseType)} (${formatNames(edu?.courseCategory)}) ${edu?.courseName ? `${formatNames(edu?.courseName)}` : ""
                                                }`}
                                        </p>
                                    )}

                                    {edu?.institutionName && (
                                        <p className="text-black font-normal text-sm sm:text-base py-1">
                                            {formatNames(edu?.institutionName)}, {edu?.state ? formatNames(edu?.state) : ''}
                                        </p>
                                    )}

                                    <div className="text-gray-500 text-sm sm:text-base">
                                        {edu?.startDate && (
                                            <span>
                                                {new Date(edu?.startDate).toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                })}
                                            </span>
                                        )}
                                        {edu?.endDate ? (
                                            <span>
                                                {`${edu?.startDate ? " -" : ""} `}
                                                {new Date(edu?.endDate).toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                })}
                                            </span>
                                        ) : (
                                            <span> - Present</span>
                                        )}
                                    </div>

                                    {/* Mode + Grade */}
                                    {edu?.mode && (
                                        <div className="flex flex-wrap flex-row justify-start gap-3 text-sm mt-2">
                                            <p className="text-primary-300 bg-blue-200 px-2 rounded-lg">
                                                {formatNames(edu?.mode)}
                                            </p>
                                            <p className="text-primary-300 bg-blue-200 px-2 rounded-lg">
                                                {edu?.grade?.type === "cgpa"
                                                    ? `${edu?.grade?.value} cgpa`
                                                    : `${edu?.grade?.value} %`}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center my-3">No Data Available!</p>
                )}
            </div>

            {/* Pagination */}
            <div>
                <div className="mx-auto mt-7 flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-3">
                    <div className="flex items-center gap-2">
                        <label htmlFor="recordsPerPage" className="text-sm">
                            Records per page:
                        </label>
                        <select
                            id="recordsPerPage"
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerpage(parseInt(e.target.value, 10))}
                            className="ml-2 px-3 py-1 border rounded text-sm"
                        >
                            {[5, 10, 25, 50, 75, 100].map((n) => (
                                <option key={n} value={n}>
                                    {n}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="text-sm">Total Educations: {totalEducation}</div>
                </div>

                <div className="flex justify-center items-center gap-4 mt-4">
                    <span
                        className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${currentPage === 1
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                            }`}
                        onClick={() => handlePagination("prev")}
                    >
                        chevron_left
                    </span>
                    <span className="text-sm md:text-base">
                        {currentPage} of {totalPage}
                    </span>
                    <span
                        className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${currentPage === totalPage
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                            }`}
                        onClick={() => handlePagination("next")}
                    >
                        chevron_right
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Education